<template>
  <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.75 18V19.5625C12.75 20.1094 12.3203 20.5 11.8125 20.5H1.1875C0.640625 20.5 0.25 20.1094 0.25 19.5625V5.1875C0.25 4.67969 0.640625 4.25 1.1875 4.25H4V15.8125C4 17.0234 4.97656 18 6.1875 18H12.75ZM12.75 4.5625C12.75 5.10938 13.1406 5.5 13.6875 5.5H17.75V15.8125C17.75 16.3594 17.3203 16.75 16.8125 16.75H6.1875C5.64062 16.75 5.25 16.3594 5.25 15.8125V1.4375C5.25 0.929688 5.64062 0.5 6.1875 0.5H12.75V4.5625ZM17.4375 3.35156C17.6328 3.54688 17.75 3.78125 17.75 4.01562V4.25H14V0.5H14.2344C14.4688 0.5 14.7031 0.617188 14.8984 0.8125L17.4375 3.35156Z"
      fill="#0088A4"
    />
  </svg>
</template>
